export class CookieNames {
  static readonly IS_THEME_DARK: string = '_IS_THEME_DARK_';
  static readonly CLEARING_VIEW_SELECTED: string = '_CLEARING_VIEW_SELECTED_';
  static readonly CLEARING_ORDER_TRADEMODE: string = '_CLEARING_ORDER_TRADEMODE_';
  static readonly CLEARING_TRADE_AGGREGATES: string = '_CLEARING_TRADE_AGGREGATES_';
  static readonly CLEARING_STATE_FILTER_SELECTED: string = '_CLEARING_STATE_FILTER_SELECTED_';
  static readonly TRADE_SELECTION_BASE: string = '_TRADE_SELECTION_BASE_';
  static readonly TRADE_SELECTION_FILTER_SELECTED_: string = '_TRADE_SELECTION_FILTER_SELECTED_';
  static readonly TRADE_SELECTION_INFO: string = '_TRADE_SELECTION_INFO_';
  static readonly TRADE_SELECTION_INFO_LOCK: string = '_TRADE_SELECTION_INFO_LOCK_';
  static readonly TRADE_CTRL_A_MODE: string = '_TRADE_CTRL_A_MODE_';
  static readonly CLEARING_FILTERS_SORT_SELECTED_: string = '_CLEARING_FILTERS_SORT_SELECTED_';
  static readonly CLEARING_SIDE_BAR_MAXIMIZED: string = '_CLEARING_SIDE_BAR_MAXIMIZED_';
  static readonly CLEARING_VISIBLE_COLUMNS_: string = '_CLEARING_VISIBLE_COLUMNS_';
  static readonly CLEARING_TABLE_MAXIMIZED_: string = '_CLEARING_TABLE_MAXIMIZED_';
  static readonly MENU_SIDE_BAR_MAXIMIZED: string = '_MENU_SIDE_BAR_MAXIMIZED_';
  static readonly ARCHIVE_FORM_RECORD: string = '_ARCHIVE_FORM_RECORD_';
  static readonly ARCHIVE_FORM_FORCEDAY: string = '_ARCHIVE_FORM_FORCEPREVIOUSDAY_';
  static readonly ARCHIVE_FORM_USEPROFILES: string = '_ARCHIVE_FORM_USEPROFILES_';
  static readonly ARCHIVE_PROFILE_TYPES: string = '_ARCHIVE_PROFILE_TYPES_';
  static readonly PAGE_BEFORE_LOGOUT: string = '_PAGE_BEFORE_LOGOUT_';

  static readonly ARCHIVE_RECAP_FAV_LIST: string = '_ARCHIVE_RECAP_FAV_LIST_';
  static readonly ETICKET_VIEW_SELECTED: string = '_ETICKET_VIEW_SELECTED_';

  static readonly BILLING_INVOICE_REQUEST: string = '_BILLING_INVOICE_REQUEST_';
  static readonly ORDER_AMENDMENT_REQUEST: string = '_ORDER_AMENDMENT_REQUEST_';
}
